import { api } from "../api/api_axios";

export async function createRemoteSession() {
  return (await api.post("/remote/sessions/", {})).data;
}

export async function claimRemoteSession(pairToken) {
  return (await api.post("/remote/sessions/claim/", { pairToken })).data;
}

export async function reconnectRemoteSession(sessionId, reconnectToken) {
  return (await api.post("/remote/sessions/reconnect/", { sessionId, reconnectToken })).data;
}

export async function resetRemoteSession(sessionId, hostToken) {
  return (await api.post(`/remote/sessions/${sessionId}/reset/`, {}, {
    headers: { Authorization: `Bearer ${hostToken}` },
  })).data;
}

export async function endRemoteSession(sessionId, hostToken) {
  await api.post(`/remote/sessions/${sessionId}/end/`, {}, {
    headers: { Authorization: `Bearer ${hostToken}` },
  });
}

export function remoteSocketUrl(ticket) {
  const configured = process.env.REACT_APP_REMOTE_SIGNALING_SERVER;
  if (configured) {
    const url = new URL(configured, window.location.href);
    url.searchParams.set("ticket", ticket);
    return url.toString();
  }
  const apiUrl = new URL(api.defaults.baseURL || "/api", window.location.origin);
  apiUrl.protocol = apiUrl.protocol === "https:" ? "wss:" : "ws:";
  apiUrl.pathname = "/ws/remote/";
  apiUrl.search = "";
  apiUrl.searchParams.set("ticket", ticket);
  return apiUrl.toString();
}
